const styles = {
  label: {
    color: '#999 !important',
    fontSize: '.625rem !important',
    fontWeight: 'bold !important',
    letterSpacing: '.125rem !important',
    lineHeight: '.625rem !important',
    textTransform: 'uppercase !important',
    marginBottom: '.625rem !important',
    textAlign: 'left !important',
  },
  defaultText: {
    fontSize: '.75rem !important',
    whiteSpace: 'nowrap !important',
  },
  value: {
    textAlign: 'left !important',
    pointerEvents: 'all',

    '& span': {
      fontWeight: '500',
      pointerEvents: 'none',
      textTransform: 'capitalize',
    },
  },
  secondaryData: {
    fontSize: '.875rem !important',
    marginTop: '.625rem !important',
    lineHeight: '.875rem !important',
    textAlign: 'left !important',
    textTransform: 'lowercase !important',
    color: '#999 !important',

    '@global [data-direction= "up"]': {
      color: '#39e27a !important',
    },
    '@global [data-direction= "down"]': {
      color: '#f55947 !important',
    },
  },
  icon: {
    color: '#9a9897 !important',
    fontSize: '.850rem !important',
    marginLeft: '.250rem !important',
    cursor: 'pointer',
  },
  secondaryText: {
    whiteSpace: 'nowrap !important',
  },
  '@global .ui.statistics': {
    margin: '0 !important',
  },
  '@global .ui.statistic > .value, .ui.statistics .statistic > .value': {
    color: '#683caf !important',
    fontSize: '1.875rem !important',
    marginTop: '.625rem !important',
  },
};

export default styles;
